(function(){
  var root = document.querySelector('[data-pdp-acc]');
  if(!root) return;

  var items = Array.prototype.slice.call(
    root.querySelectorAll('details.pdp-acc__item')
  );

  var DURATION = 380;

  function panelOf(d){ return d.querySelector('.pdp-acc__panel'); }

  function openWithAnim(d){
    var p = panelOf(d);
    if(!p) return;

    items.forEach(function(other){
      if(other !== d && other.open) closeWithAnim(other);
    });

    d.open = true;
    p.style.height = '0px';
    p.offsetHeight;

    var target = p.scrollHeight;
    p.style.height = target + 'px';

    setTimeout(function(){
      if(d.open) p.style.height = 'auto';
    }, DURATION);
  }

  function closeWithAnim(d){
    var p = panelOf(d);
    if(!p){ d.open = false; return; }

    var start = p.scrollHeight;
    p.style.height = start + 'px';
    p.offsetHeight;
    p.style.height = '0px';

    setTimeout(function(){
      d.open = false;
    }, DURATION);
  }

  items.forEach(function(d){
    var p = panelOf(d);
    if(!p) return;

    p.style.height = d.open ? 'auto' : '0px';

    var sum = d.querySelector('summary');
    if(!sum) return;

    sum.addEventListener('click', function(e){
      e.preventDefault();
      if(d.open) closeWithAnim(d);
      else openWithAnim(d);
    });
  });
})();